import React, { memo, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { noopVoid } from 'reactApp/utils/helpers';

import styles from './Link.css';
import { getRouterLinkUrl } from './Link.helpers';
import { IProps } from './Link.types';

export const Link = memo(
    ({ children, id, href, storage, handleGoTo = noopVoid, handleClick = noopVoid, noLink = false }: IProps): ReactElement => {
        const currentStorage = useSelector(getCurrentStorage);

        const isRouterLink = !noLink && getStorage(storage).isReactPage && getStorage(currentStorage).isReactPage;
        const routerLinkUrl = getRouterLinkUrl(id, storage, href);

        return (
            <>
                {isRouterLink ? (
                    <RouterLink to={routerLinkUrl} className={styles.root} onClick={handleClick}>
                        {children}
                    </RouterLink>
                ) : (
                    <div onClick={handleGoTo} className={styles.root}>
                        {children}
                    </div>
                )}
            </>
        );
    }
);

Link.displayName = 'Link';
